import { getSessionStorageItem, setSessionStorageItem, SESSION_STORAGE_EMAIL_CAPTURE } from "../../../../sessionStorage";

export const SaveQuoteLog = (quote, setLoading, setMessage, setQuoteSaved, saveMessage, setModalSaveQuoteIsOpen, onSubmit) => {
    const covrServicesUrl = window.__ENV__.REACT_APP_COVR_SERVICES_URL;

    const setEmailCaptureActive = (value) => {
      const emailCaptureObj = getSessionStorageItem(SESSION_STORAGE_EMAIL_CAPTURE);
      setSessionStorageItem(SESSION_STORAGE_EMAIL_CAPTURE, {
        ...emailCaptureObj,
        "isPartnerReferralEmailCaptureActive": value,
      });
    };

    fetch(`${covrServicesUrl}/api/SaveQuote/CreateSavedQuote`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(quote),
      })
        .then((res) => res.json())
        .then((data) => {
            setLoading(false);
            if (data){
                setEmailCaptureActive(false);
                setModalSaveQuoteIsOpen(false);
                setQuoteSaved(true);
                onSubmit();
            }
            else {
                setMessage({status:'error', message: 'Could not save your email address. Please try again'});
                setQuoteSaved(false);
            }
        })
        .catch((error) => {
           setLoading(false);
           setMessage({status:'error', message: 'Could not save your email address. Please try again'});
           setQuoteSaved(false);
        })
        .finally(() => {
          setLoading(false);
        });
}